/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetEmployerOnboardingStatusEmployerInviteDtoFromJSON, GetEmployerOnboardingStatusEmployerInviteDtoToJSON, } from './GetEmployerOnboardingStatusEmployerInviteDto.js';
import { GetEmployerOnboardingStatusEmployerDtoFromJSON, GetEmployerOnboardingStatusEmployerDtoToJSON, } from './GetEmployerOnboardingStatusEmployerDto.js';
import { EmployerOnboardingStatusFromJSON, EmployerOnboardingStatusToJSON, } from './EmployerOnboardingStatus.js';
/**
 * Check if a given object implements the GetEmployerOnboardingStatusResult interface.
 */
export function instanceOfGetEmployerOnboardingStatusResult(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
export function GetEmployerOnboardingStatusResultFromJSON(json) {
    return GetEmployerOnboardingStatusResultFromJSONTyped(json, false);
}
export function GetEmployerOnboardingStatusResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': EmployerOnboardingStatusFromJSON(json['status']),
        'employerInvite': json['employerInvite'] == null ? undefined : GetEmployerOnboardingStatusEmployerInviteDtoFromJSON(json['employerInvite']),
        'employer': json['employer'] == null ? undefined : GetEmployerOnboardingStatusEmployerDtoFromJSON(json['employer']),
    };
}
export function GetEmployerOnboardingStatusResultToJSON(json) {
    return GetEmployerOnboardingStatusResultToJSONTyped(json, false);
}
export function GetEmployerOnboardingStatusResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': EmployerOnboardingStatusToJSON(value['status']),
        'employerInvite': GetEmployerOnboardingStatusEmployerInviteDtoToJSON(value['employerInvite']),
        'employer': GetEmployerOnboardingStatusEmployerDtoToJSON(value['employer']),
    };
}
